import "./ConfirmarTurnoKin.css";
import camelize from "../../../../global/utils/camelize";
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";

const ConfirmarTurnoKin = ({
  confirmarTurnoKin,
  paciente,
  nroSesion,
  centro,
  ubicacion,
  dissmiss,
}) => {
  const { textosState } = useContext(PortalContext);

   // Cambio de contexto
   const {
    authState,
  } = useContext(GlobalContext);

  return (
    <div className="ptur-ConfirmarTurnoKin-container">
      <div className="ptur-ConfirmarTurnoKin-header bgcG-latex30">
        <span className="c-white rb24b">
          Confirmar sus 10 turnos de Kinesiología
        </span>
      </div>
      <div className="ptur-ConfirmarTurnoKin-body">
        <div className="ptur-ConfirmarTurnoKin-informacionTurnos">
          {!paciente ? (
            <p className="rb18l">
              Paciente:{" "}
              <span className="rb18b">
                {camelize(authState.auth.data.paciente.nombre)}
              </span>
            </p>
          ) : (
            <p className="rb18l">
              Paciente:{" "}
              <span className="rb18b">
                {camelize(paciente.paciente.nombre)}
              </span>
            </p>
          )}
          <p className="rb18l">
            Sesiones: <span className="rb18b">10</span>
          </p>

          <p className="rb18l">
            <span className="rb18b">{camelize(centro)}</span>
          </p>
          <p>{camelize(ubicacion)}</p>
        </div>
        <div className="ptur-ConfirmarTurnoKin-recordatorio">
          <div
            className="ptur-ConfirmarTurnoKin-recordatorioTxt rb16l"
            dangerouslySetInnerHTML={{
              __html:
                textosState.textos.data.msjConfirmacionTurnoKIN.descripcion,
            }}
          ></div>
          <div className="ptur-ConfirmarTurnoKin-botones">
            <button
              onClick={dissmiss}
              className="ptur-ConfirmarTurnoKin-btn-outline bgc-white rb16m c-latex30"
            >
              Volver
            </button>
            <button
              onClick={() => confirmarTurnoKin(nroSesion)}
              className="ptur-ConfirmarTurnoKin-btn bgc-primary rb16m c-white"
            >
              {" "}
              Reservar turno
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmarTurnoKin;
